import { useContext } from "react"
import * as React from "react"
import { Context } from "../../../store/store"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	formElementChanged: Function
	validation: Object
}
const MafoQuestionFour: React.FC<MafoQuestionProps> = ({ formElementChanged, validation }) => {
	const { globalState } = useContext(Context)
	return (
		<>
			<h3 className="mb-2 text-left text-center font-Alpro  text-[24px] text-blue lg:text-center lg:text-[32px]">Warum hast Du das Alpro Produkt gekauft?* (Mehrfach-Antwort möglich)</h3>
			<div className="mx-auto grid grid-cols-1 flex-row text-left lg:max-w-[75%]">
				<ElemCheckboxMafo
					label={<>Ich habe es
						aufgrund dieser
						Aktion gekauft  </>}
					props={{
						type: "checkbox",
						name: "question4",
						value: "a",
						required: true,
						onClick: e => formElementChanged(e, "question4"),
					}}
					hasError={validation["invalid_question4"] ? true : false}
					className="pb-2 text-[32px] text-green lg:mt-6"
					errMsg={validation["invalid_question4_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Alpro Produkte schmecken besser als andere Marken</>}
					props={{
						type: "checkbox",
						name: "question4",
						value: "b",
						required: true,
						onClick: e => formElementChanged(e, "question4"),
					}}
					hasError={validation["invalid_question4"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question4_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Alpro Produkte sind gesünder als andere Marken</>}
					props={{
						type: "checkbox",
						name: "question4",
						value: "c",
						required: true,
						onClick: e => formElementChanged(e, "question4"),
					}}
					hasError={validation["invalid_question4"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question4_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Ich finde Alpro als Marke einfach gut</>}
					props={{
						type: "checkbox",
						name: "question4",
						value: "d",
						required: true,
						onClick: e => formElementChanged(e, "question4"),
					}}
					hasError={validation["invalid_question4"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question4_errMsg"] || ""}
				/>
			</div>
		</>
	)
}

export default MafoQuestionFour
